import React from 'react';
import { useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import { FaGamepad, FaHome, FaSkullCrossbones } from 'react-icons/fa';

export default function NotFound() {
    const navigate = useNavigate();

    return (
        <div className="min-h-[calc(100vh-200px)] flex items-center justify-center relative overflow-hidden">
            {/* Background Decorations */}
            <div className="absolute top-1/4 left-1/4 w-96 h-96 bg-primary/10 rounded-full blur-[120px] animate-pulse" />
            <div className="absolute bottom-1/4 right-1/4 w-96 h-96 bg-purple-500/10 rounded-full blur-[120px] animate-pulse delay-700" />

            <motion.div 
                initial={{ opacity: 0, scale: 0.9 }}
                animate={{ opacity: 1, scale: 1 }}
                transition={{ duration: 0.5 }}
                className="relative z-10 text-center px-4"
            >
                <div className="relative mb-8">
                    <motion.div 
                        initial={{ rotate: -10 }}
                        animate={{ rotate: 10 }}
                        transition={{ repeat: Infinity, duration: 2, repeatType: "reverse", ease: "easeInOut" }}
                        className="text-8xl text-primary/40 flex justify-center"
                    >
                        <FaSkullCrossbones className="filter drop-shadow-[0_0_30px_rgba(98,99,237,0.4)]" />
                    </motion.div>
                    
                    <h1 className="text-[180px] font-black text-white leading-none tracking-tighter opacity-10 absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 select-none">
                        404
                    </h1>
                </div>

                <div className="bg-white/5 border border-white/10 backdrop-blur-md rounded-[40px] p-12 max-w-lg mx-auto shadow-2xl relative overflow-hidden">
                    <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-transparent via-primary to-transparent opacity-50" />
                    
                    <h2 className="text-3xl font-bold text-white mb-4 tracking-tight">Mission Failed</h2>
                    <p className="text-gray-400 mb-10 leading-relaxed">
                        The objective was not found. The page you're seeking has either been relocated or ceased to exist in this timeline.
                    </p>

                    <div className="flex flex-col sm:flex-row gap-4 justify-center">
                        <motion.button 
                            whileHover={{ scale: 1.05 }}
                            whileTap={{ scale: 0.95 }}
                            onClick={() => navigate('/admin')}
                            className="px-8 py-4 rounded-2xl bg-gradient-primary text-white font-bold flex items-center justify-center gap-2 shadow-lg shadow-primary/20"
                        >
                            <FaHome /> Respawn at Base
                        </motion.button>
                        <motion.button 
                            whileHover={{ scale: 1.05 }}
                            whileTap={{ scale: 0.95 }}
                            onClick={() => navigate(-1)}
                            className="px-8 py-4 rounded-2xl bg-white/5 border border-white/10 text-white font-bold flex items-center justify-center gap-2 hover:bg-white/10 transition-all"
                        >
                            <FaGamepad /> Retry Last Move
                        </motion.button>
                    </div>
                </div>

                <div className="mt-12 flex justify-center gap-8 opacity-20">
                    <FaGamepad size={32} className="text-white" />
                    <div className="h-8 w-px bg-white/30" />
                    <span className="font-black text-white tracking-[0.3em] text-sm uppercase">End of Line</span>
                </div>
            </motion.div>
        </div>
    );
}